<template>
	<az-container class="listagem">
		<v-card tile elevation="0">
			<v-row no-gutters>
				<v-col cols="6">
					<v-card-text class="ma-0 pl-2 pt-5">
						<v-form v-model="isFormValid" ref="frmGerarRelatorioSaldos" lazy-validation>
							<v-row>
								<v-col cols="12" sm="6">
									<label-personalizado
										nome-campo="Nº Ata"
										obrigatorio-por-padrao
										class="label-campos"
									></label-personalizado>
									<v-autocomplete
										v-model="idAta"
										:items="atasDataSource"
										placeholder="Busque pelo número da ata"
										class="ma-0 py-2"
										name="NumeroAta"
										clearable
										item-text="numeroAta"
										item-value="id"
										:rules="numeroAtaRules"
										:search-input.sync="campoNumeroAta"
										@update:search-input.capture="buscarAtas()"
									></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6">
									<label-personalizado nome-campo="Órgão" class="label-campos"></label-personalizado>
									<v-autocomplete
										v-model="idOrgao"
										:items="orgaosDataSource"
										placeholder="Selecione o órgão"
										class="ma-0 py-2"
										name="NumeroOrgao"
										:disabled="!habilitarCampoOrgaos"
										clearable
										item-text="siglaDescricao"
										item-value="id"
									>
										<template #item="{ item, attrs, on }">
											<v-list-item v-bind="attrs" v-on="on">
												<v-list-item-content>
													<texto-tooltip
														:tamanho-maximo="50"
														:texto="item.siglaDescricao"
													></texto-tooltip>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-autocomplete>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-col>
				<v-col cols="auto" class="d-flex align-center">
					<v-card-actions>
						<botao-primario
							nome-botao="Gerar"
							@click="gerarRelatorioSaldos"
							v-az-auth="permissoes.relatorioControleSaldos"
							:disabled="!isFormValid"
						></botao-primario>
					</v-card-actions>
				</v-col>
			</v-row>
		</v-card>
		<modal-confirmacao
			titulo-modal="Tudo certo, relatório em processamento"
			mensagem="Relatório adicionado na fila para processamento e será encaminhado por e-mail assim que for concluído."
			:exibir="exibirModalInformativo"
			@cancelar="exibirModalInformativo = false"
			icone-modal="task_alt"
			cor-icone="#A5DC86"
		>
			<template #acoes>
				<botao-primario nomeBotao="Voltar" @click="exibirModalInformativo = false"></botao-primario>
			</template>
		</modal-confirmacao>
	</az-container>
</template>

<script>
import BotaoPrimario from '@/views/components/BotaoPrimario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { actionTypes } from '@/core/constants'
import TextoTooltip from '@/views/components/TextoTooltip'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'controle-saldos',
	components: { TextoTooltip, LabelPersonalizado, BotaoPrimario },
	mixins: [validacaoFormulario],
	data() {
		return {
			isFormValid: true,
			numeroAtaRules: [(v) => this.regraObrigatoriedade(v, 'Número ata é obrigatório.')],
			idAta: null,
			campoNumeroAta: null,
			atasDataSource: [],
			paginacaoCampoAta: paginacaoListagem('', 50),
			idOrgao: null,
			orgaosDataSource: [],
			habilitarCampoOrgaos: false,
			exibirModalInformativo: false,
		}
	},
	watch: {
		async idAta() {
			if (!this.idAta) {
				this.orgaosDataSource = []
				this.idOrgao = null
				this.habilitarCampoOrgaos = false
				return
			}

			this.habilitarCampoOrgaos = true
			await this.buscarOrgaos()
		},
	},
	async mounted() {
		await this.buscarAtas()
	},
	methods: {
		async buscarAtas() {
			const { itens } = await this.$store.dispatch(actionTypes.RELATORIOS.CONTROLE_SALDOS.BUSCAR_ATAS, {
				paginacao: this.paginacaoCampoAta,
				numeroAta: this.campoNumeroAta,
			})

			this.atasDataSource = itens
		},
		async buscarOrgaos() {
			const { itens } = await this.$store.dispatch(
				actionTypes.RELATORIOS.CONTROLE_SALDOS.BUSCAR_ORGAOS,
				this.idAta,
			)

			this.orgaosDataSource = itens
		},
		async gerarRelatorioSaldos() {
			if (this.$refs.frmGerarRelatorioSaldos.validate()) {
				const payload = { idAta: this.idAta, idOrgao: this.idOrgao }
				await this.$store
					.dispatch(actionTypes.RELATORIOS.CONTROLE_SALDOS.GERAR_RELATORIO, payload)
					.then((resp) => {
						if (resp === 0) this.exibirModalInformativo = true
					})
			}
		},
	},
}
</script>
<style scoped lang="stylus">
.label-campos
	color rgba(0, 0, 0, 0.54) !important
</style>
